var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabContainer = void 0;
var TabContainer_1 = __importDefault(require("./TabContainer"));
exports.TabContainer = TabContainer_1.default;
exports.default = TabContainer_1.default;
//# sourceMappingURL=index.js.map